export enum CodeRepos {
  GitHub = 'GitHub',
  GitLab = 'GitLab',
  AzureCode = 'Azure',
  Bitbucket = 'Bitbucket',
}

export const CodeReposIdsMap = new Map([
  ['1', CodeRepos.GitHub],
  ['2', CodeRepos.GitLab],
  ['3', CodeRepos.Bitbucket],
  ['12', CodeRepos.AzureCode],
]);

export enum OnboardingSteps {
  Login = 'Login',
  Connect = 'Connect',
  ChooseRepos = 'ChooseRepos',
  Discovery = 'Discovery',
}

export type RepoNode = {
  id: string;
  name: string;
  isMonitored: boolean;
  resourceType: NodeTypes;
  children: RepoNode[];
};

export enum NodeTypes {
  Node = 'node',
  Edge = 'edge',
}

export interface FlattenedItem {
  deepness: number;
  parents: string[];
  isIndeterminate: boolean;
  expanded: boolean;
  selected: boolean;
  id: string;
  children: RepoNode[];
  name: string;
}

export interface ControlObject {
  [key: string]: {
    expanded: boolean;
    selected: boolean;
    nodeType: NodeTypes;
  };
}
